const yes = (v) => v === true || v === 1 || v === "1";
export function configFor(d) {
  const type =
    d.documento_tipo?.clave_documento_tipo ||
    d.documentoTipo?.clave_documento_tipo;
  return {
    idDocumento: d.id,
    claveTipo: type,
    singular: d.descripcion || "Documento",
    plural: d.descripcion || "Documentos",
    genero: "m",
    esFactura: yes(d.generar_cfdi),
    esNotaVenta: type === "FACC" && !yes(d.generar_cfdi),
    requiereAlmacen: Number(d.afecta_inventarios) !== 0,
    permiteMultiplesPrevios: true,
    enabled: true,
  };
}
export function canUsePrevious(config, record, configuration) {
  return (
    !record &&
    !(config.claveTipo === "CVTA" && !yes(configuration?.requiere_previo)) &&
    (yes(configuration?.requiere_previo) ||
      Boolean(configuration?.previos?.length))
  );
}
export function previousCurrency(documents) {
  const values = documents.map((d) => ({
    id_moneda: Number(d.id_moneda || d.moneda?.id),
    tipo_cambio: Number(d.tipo_cambio || 1),
  }));
  const first = values[0];
  if (
    !first ||
    !first.id_moneda ||
    values.some(
      (v) =>
        v.id_moneda !== first.id_moneda ||
        Math.abs(v.tipo_cambio - first.tipo_cambio) > 0.000001
    )
  )
    throw new Error(
      "Los documentos previos deben tener la misma moneda y tipo de cambio."
    );
  return first;
}
